module.exports = __webpack_public_path__ + "assets/images/key/key_kl_2021.svg?v=3b88ed27";